import React, { useEffect, useState } from 'react'
import { getUserNotification } from '../../Common/apis';
import { toast } from 'react-toastify';
import Loader from '../Loader/Loader';
import moment from 'moment';

function Notification() {
    const [nBtn, setNBtn] = useState("News");
    const items = Array.from({ length: 8 }, (_, index) => ({
        id: index + 1,
    }));

    const [notification, setNotification] = useState(null)
    const [loading, setLoading] = useState(false);


    const fetchNotification = async () => {
        setLoading(true);
        try {
            const response = await getUserNotification();
            setNotification(response.data);
        } catch (error) {
            toast.error(error.message);
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        fetchNotification();
    }, []);


    return (
        <>
            {loading && <Loader />}
            <div>
                <h6 className="font-[700] font-manrope text-[24px] text-[#000000] pb-[19px]">Notification</h6>
                <div className='bg-[#F6F8FA] border border-[#E7E4FC] rounded-[12px] p-[30px]'>
                    <div className="flex gap-[8px] pb-[24px]">
                        <button onClick={() => setNBtn("News")} className={`bg-[#FFFFFF] py-[9px] max-w-[164px] w-full text-center font-[500] font-manrope text-[16px] border-b-[2px] ${nBtn === "News" ? "text-[#FF6000] border-[#FF6000]" : "text-[#666D80] border-transparent"}`}>News</button>
                        <button onClick={() => setNBtn("Inbox")} className={`bg-[#FFFFFF] py-[9px] max-w-[164px] w-full text-center font-[500] font-manrope text-[16px] border-b-[2px] ${nBtn === "Inbox" ? "text-[#FF6000] border-[#FF6000]" : "text-[#666D80] border-transparent"}`}>Inbox</button>
                    </div>
                    {nBtn === "News" &&
                        <>
                            {notification?.length === 0 ? (
                                <div className="text-gray-500 text-center py-4">
                                    You have no new notifications.
                                </div>
                            ) : (
                                <div className="grid grid-cols-1 gap-[30px]">
                                    {notification?.map((e) => {
                                        const getDaysAgo = (createdAt) => {
                                            const createdDate = new Date(createdAt);
                                            const now = new Date();
                                            const timeDiff = now - createdDate;
                                            const daysAgo = Math.floor(timeDiff / (1000 * 60 * 60 * 24)); // ms to days
                                            return daysAgo;
                                        };
                                        const daysAgo = getDaysAgo(e.createdAt);

                                        return (
                                            <div key={e?.id} className="flex flex-col p-[12px] gap-[12px]">
                                                <div className='flex justify-between items-center'>
                                                    <div className="flex gap-[8px] items-center">
                                                        <img src="/assets/profile/img2.png" alt="" />
                                                        <div>
                                                            <div className="flex items-center gap-[4px]">
                                                                <h6 className="font-[600] font-manrope text-[11px] text-[#333333]">Rodger Alberto</h6>
                                                                <img src="/assets/profile/check-circle.svg" alt="" />
                                                            </div>
                                                            <p className="font-[400] font-manrope text-[11px] text-[#666666]">{e?.Notifications + ' On ' + moment(e?.createdAt).format('DD MMM, YYYY')}</p>
                                                        </div>
                                                    </div>
                                                    <p className="font-[400] font-manrope text-[11px] text-[#4D4D4D]">{daysAgo === 0 ? 'Today' : `${daysAgo} day${daysAgo > 1 ? 's' : ''} ago`}</p>
                                                </div>
                                                <p className="font-[700] font-manrope text-[13px] text-[#333333]">{e?.Notifications}</p>
                                            </div>
                                        )
                                    })}
                                </div>
                            )}
                        </>
                    }
                    {nBtn === "Inbox" &&
                        <>
                            {notification?.length === 0 ? (
                                <div className="text-gray-500 text-center py-4">
                                    You have no new notifications.
                                </div>
                            ) : (

                                <div className="grid grid-cols-1 gap-[16px]">
                                    {items?.map((e) => {
                                        return (
                                            <div key={e?.id} className="p-[12px]">
                                                <div className="flex gap-[8px] items-start w-full">
                                                    <img src="/assets/profile/Avatars.svg" alt="" />
                                                    <div className='flex justify-between w-full items-start'>
                                                        <div>
                                                            <h6 className="font-[700] font-manrope text-[13px] text-[#333333]">URGENT! Help residents affected by flood in Rusia</h6>
                                                            <p className="font-[400] font-manrope text-[11px] text-[#666666]">Your donation on 20 May, 2024</p>

                                                        </div>
                                                        <p className="font-[400] font-manrope text-[11px] text-[#4D4D4D]">2 days ago</p>
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    })}
                                </div>
                            )}
                        </>
                    }
                </div>
            </div>
        </>
    )
}

export default Notification